import { io, Socket } from 'socket.io-client';
import { TWaitingRoomSocketConnectionInitiateData } from '../store/V2/WaitingRoomSlice';

let waitingRoomSocket: Socket | undefined;

export const getWaitingRoomSocket = (
  data: TWaitingRoomSocketConnectionInitiateData
) => {
  if (!waitingRoomSocket) {
    const baseUrl = process.env.REACT_APP_TUTOPIYA_BASE_URL_V2;

    if (!baseUrl) {
      throw new Error('REACT_APP_TUTOPIYA_BASE_URL is not defined');
    }

    waitingRoomSocket = io(`${baseUrl}/waitingRoom`, {
      autoConnect: false,
      auth: data,
      transports: ['websocket'],
    });
  }

  return waitingRoomSocket;
};

export default getWaitingRoomSocket;
